import { useState } from "react";
import { api } from "@/lib/api";
import { X, ShieldCheck, ShieldAlert, ScanLine } from "lucide-react";

export default function COAPanel({ onClose, track }) {
  const [batch, setBatch] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const scan = async () => {
    if (!batch.trim()) return;
    setBusy(true); setRes(null);
    try {
      const { data } = await api.get(`/vr/coa/${encodeURIComponent(batch.trim())}`);
      setRes(data);
      track && track("coa_scan", { meta: { batch: batch.trim(), found: data.authentic } });
    } catch { setRes({ authentic: false, message: "BATCH NOT FOUND" }); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" data-testid="vr-coa-panel">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-3xl bg-[#080c12] border border-emerald-400/20 p-6">
        <button onClick={onClose} className="absolute top-3 right-3 p-2 text-slate-400 hover:text-white"><X size={18} /></button>
        <div className="flex items-center gap-2 text-emerald-300 font-mono text-xs tracking-widest"><ScanLine size={15} /> QUALITY + COA CENTER</div>
        <h2 className="text-2xl font-semibold text-white mt-1">Verify a Batch</h2>
        <p className="text-sm text-slate-400 mt-1">Enter a batch / lot number to confirm authenticity and view its certificate of analysis.</p>
        <div className="mt-4 flex gap-2">
          <input value={batch} onChange={(e) => setBatch(e.target.value)} onKeyDown={(e) => e.key === "Enter" && scan()}
            placeholder="e.g. CG5460" data-testid="vr-coa-input"
            className="flex-1 bg-black/40 border border-white/15 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-emerald-400/60" />
          <button onClick={scan} disabled={busy} data-testid="vr-coa-scan" className="px-4 rounded-xl bg-emerald-400 text-black font-semibold disabled:opacity-50">Scan</button>
        </div>
        {res && (
          <div className={`mt-4 rounded-2xl p-4 border ${res.authentic ? "border-emerald-400/40 bg-emerald-500/10" : "border-rose-400/40 bg-rose-500/10"}`} data-testid="vr-coa-result">
            <div className={`flex items-center gap-2 font-semibold ${res.authentic ? "text-emerald-300" : "text-rose-300"}`}>
              {res.authentic ? <ShieldCheck size={18} /> : <ShieldAlert size={18} />} {res.message}
            </div>
            {res.authentic && res.coa && (
              <div className="mt-3 grid grid-cols-2 gap-2 text-xs font-mono text-slate-300">
                <Kv k="Batch" v={res.coa.batch} /><Kv k="Purity" v={res.coa.purity} />
                <Kv k="Test date" v={res.coa.testing_date} /><Kv k="Lab" v={res.coa.lab || res.coa.laboratory} />
                {res.coa.document_url && <a className="col-span-2 text-cyan-300 underline mt-1" href={res.coa.document_url} target="_blank" rel="noreferrer">View original COA →</a>}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
const Kv = ({ k, v }) => (<div><div className="text-slate-500">{k}</div><div className="text-slate-100">{v || "—"}</div></div>);
